//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ExpandableList from 'components/combinedBlocks/ExpandableList.vue'
import TextBlock from 'components/blocks/Text.vue'
import Integrationform from 'components/combinedBlocks/IntegrationForm.vue'

import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'currentSection',
      'sections'
    ])
  },
  components: {
    ExpandableList,
    TextBlock,
    Integrationform,
  }
}



// WEBPACK FOOTER //
// ./components/globalBlocks/ScrolledSections.vue